'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const {
    Component
} = React;
const Relay = require('react-relay');
const {
    MakeOfferModal,
    LowBall,
    MakeOffer,
    AbandonMakeOfferModal,
    ModalWrapper,
    Confirmation
} = require('dibs-contact-modal');
const getNetworkLayer = require('../../../global/relayClientNetworkLayer');
const abExperiments = require('../../../global/abExperiments.es');
const { getUserId, cookieJarConstants } = require('dibs-cookie-jar');

const checkoutStorage = require('../../../checkout/helpers/checkout-storage.es');

function getNewEnvironment() {
    const e = new Relay.Environment();
    e.injectNetworkLayer(getNetworkLayer());
    return e;
}

let optimizelyVariant = 'control';
if (abExperiments.makeOfferCheckbox) {
    Promise.resolve(abExperiments.makeOfferCheckbox)
        .then(res => { optimizelyVariant = res; });
}

class MakeOfferRenderer extends Component {
    render() {
        const { modalProps } = this.props;
        const { itemId, sellerId } = modalProps;
        const userId = getUserId(document.cookie, cookieJarConstants.MASQUERADE_BUYER);

        const queryConfig = {
            queries: {
                viewer: (component, params) => Relay.QL`
                query {
                    viewer {
                        ${component.getFragment('viewer', params)}
                    }
                }
            `
            },
            name: 'MakeOfferModalRoute',
            params: {
                shouldFetchUser: !!userId,
                itemId,
                sellerId,
                userId
            }
        };

        const forceEnvironmentUpdate = (variablesToSet) => {
            // manually set variables in the queryConfig because relay.setVariables
            // causes a re-render, and we're already forcing a re-render with forceUpdate
            queryConfig.params = Object.assign({}, queryConfig.params, variablesToSet);
            this.forceUpdate();
        };

        return (
            <Relay.Renderer
                Container={ MakeOfferModal }
                environment={ getNewEnvironment() }
                queryConfig={ queryConfig }
                render={({done, error, props}) => {
                    if (error) {
                        return (
                            <ModalWrapper
                                openOnRender
                                isError
                            />
                        );
                    } else if (done && props) {
                        const makeOfferProps = Object.assign({},
                            modalProps,
                            props,
                            {
                                forceEnvironmentUpdate,
                                optimizelyVariant
                            }
                        );
                        return (
                            <MakeOfferModal {...makeOfferProps}>
                                <MakeOffer />
                                <LowBall />
                                <AbandonMakeOfferModal
                                    onAbandonMakeOfferSuccess={() => {
                                        checkoutStorage.clearPreAuthOfferModalInfo();
                                        checkoutStorage.unsetSurveyInfo();
                                    }}
                                    onLeaveAbandonMakeOffer={checkoutStorage.clearPreAuthOfferModalInfo}
                                />
                                <Confirmation />
                            </MakeOfferModal>
                        );
                    } else {
                        return (
                            <ModalWrapper
                                openOnRender
                                isLoading
                            />
                        );
                    }
                }}
            />
        );
    }
}

MakeOfferRenderer.propTypes = {
    queryProps: PropTypes.object,
    modalProps: PropTypes.object
};

module.exports = MakeOfferRenderer;



// WEBPACK FOOTER //
// ./assets/js/contact/offer/components/MakeOfferRenderer.jsx